// extracted by mini-css-extract-plugin
export default {"outer":"Boarding_outer__dibIh"};